import { render, staticRenderFns } from "./ResetPasswordDialog.vue?vue&type=template&id=49c2efe0&scoped=true"
import script from "./ResetPasswordDialog.vue?vue&type=script&lang=js"
export * from "./ResetPasswordDialog.vue?vue&type=script&lang=js"
import style0 from "./ResetPasswordDialog.vue?vue&type=style&index=0&id=49c2efe0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c2efe0",
  null
  
)

export default component.exports